// extracted by mini-css-extract-plugin
export default {"positionControls":"list-config_positionControls__2X8vh","optionTrash":"list-config_optionTrash__-CtqX","addOptionBtn":"list-config_addOptionBtn__XTMeV"};